import { render, staticRenderFns } from "./SelectLanguage.vue?vue&type=template&id=6c835ab8&scoped=true"
import script from "./SelectLanguage.vue?vue&type=script&lang=ts"
export * from "./SelectLanguage.vue?vue&type=script&lang=ts"
import style0 from "./SelectLanguage.vue?vue&type=style&index=0&id=6c835ab8&prod&lang=scss"
import style1 from "./SelectLanguage.vue?vue&type=style&index=1&id=6c835ab8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c835ab8",
  null
  
)

export default component.exports